import { success } from "App/popupMessage";
import { getAllDocuments } from "Areas/Sidebar/Documents/redux/selectors";
import compact from "lodash/compact";
import difference from "lodash/difference";
import filter from "lodash/filter";
import find from "lodash/find";
import isEqual from "lodash/isEqual";
import map from "lodash/map";
import locale from "./actionCreators.locale";
import actionTypes from "./actionTypes";
import api from "./api";
export default {
    getNodeContent: (documentId, nodeId, masterNodeId, completed, rejected) => ({
        type: actionTypes.GET_NODE_CONTENT,
        payload: {
            promise: () => api.getNodeContent(nodeId)
        },
        meta: { documentId, nodeId, masterNodeId },
        scope: `${actionTypes.GET_NODE_CONTENT}_${documentId}_${nodeId}_${masterNodeId}`,
        completed: (_, { payload, meta }) => {
            completed(payload, meta);
        },
        rejected: () => {
            rejected && rejected();
        }
    }),
    getComments: (nodeId, documentId) => ({
        type: actionTypes.GET_COMMENTS,
        payload: {
            promise: () => api.getComments(nodeId, documentId)
        },
        meta: { documentId, nodeId },
        scope: `${actionTypes.GET_COMMENTS}_${documentId}_${nodeId}`
    }),
    getLikes: (nodeId, documentId) => ({
        type: actionTypes.GET_LIKES,
        payload: {
            promise: () => api.getLikes(nodeId, documentId)
        },
        meta: { documentId, nodeId },
        scope: `${actionTypes.GET_LIKES}_${documentId}_${nodeId}`
    }),
    getContentChildren: (documentId, nodeId) => ({
        type: actionTypes.GET_DOCUMENT_CONTENT_CHILDREN,
        payload: {
            promise: () => api.getContentChildren(nodeId)
        },
        meta: { documentId, nodeId },
        scope: `${actionTypes.GET_DOCUMENT_CONTENT_CHILDREN}_${documentId}_${nodeId}`
    }),
    getContentMasters: (documentId) => ({
        type: actionTypes.GET_DOCUMENT_CONTENT_MASTERS,
        payload: {
            promise: () => api.getContentMasters(documentId)
        },
        meta: { documentId },
        scope: `${actionTypes.GET_DOCUMENT_CONTENT_MASTERS}_${documentId}`
    }),
    getContentData: (documentId) => ({
        type: actionTypes.GET_DOCUMENT_CONTENT_DATA,
        payload: {
            promise: () => api.getDocumentContentData(documentId)
        },
        meta: { documentId },
        scope: `${actionTypes.GET_DOCUMENT_CONTENT_DATA}_${documentId}`
    }),
    getImageContentValue: (nodeId, contentId, completed) => ({
        type: actionTypes.GET_IMAGE_CONTENT_VALUE,
        payload: {
            promise: () => api.getImageContentValue(nodeId, contentId)
        },
        meta: { nodeId, contentId },
        scope: `${actionTypes.GET_IMAGE_CONTENT_VALUE}_${contentId}`,
        completed: (_, { payload, meta }) => {
            completed(payload, meta.contentId);
        }
    }),
    getTextContentValue: (nodeId, contentId, completed) => ({
        type: actionTypes.GET_TEXT_CONTENT_VALUE,
        payload: {
            promise: () => api.getTextContentValue(nodeId, contentId)
        },
        meta: { nodeId, contentId },
        scope: `${actionTypes.GET_TEXT_CONTENT_VALUE}_${contentId}`,
        completed: (_, { payload, meta }) => {
            completed(payload, meta.contentId);
        }
    }),
    clearData: (exceptDocumentId) => ({
        type: actionTypes.CLEAR_DATA,
        exceptDocumentId
    }),
    saveDocumentContentData: (documentId, prevData, data) => (dispatch, getState) => {
        const document = find(getAllDocuments(getState()), ["Id", documentId]);
        if (!document)
            return undefined;
        const newSourceData = {
            Id: documentId,
            Content: data
        };
        const newContentIds = map(data, "Id");
        const prevContentIds = map(prevData, "Id");
        return dispatch({
            type: actionTypes.SAVE_DOCUMENT_CONTENT_DATA,
            payload: {
                promise: () => api.saveDocumentContentData({
                    Id: newSourceData.Id,
                    DeletedIds: compact(difference(prevContentIds, newContentIds)),
                    Content: compact(filter(newSourceData.Content, item => {
                        const prev = find(prevData, ["Id", item.Id]);
                        return prev ? !isEqual(prev, item) : true;
                    }))
                })
            },
            meta: {
                documentId,
                sourceData: newSourceData
            },
            scope: `${actionTypes.SAVE_DOCUMENT_CONTENT_DATA}_${documentId}`,
            completed: (disp) => {
                disp(success(locale.buildDocumentSavedSuccessfully(document.Name)));
            },
            rejectedMessage: locale.buildDocumentSavingFailed(document.Name)
        });
    },
    updateContentData: (documentId, data) => ({
        type: actionTypes.UPDATE_CONTENT_DATA,
        documentId,
        data
    }),
    setDeleted: (ids) => ({
        type: actionTypes.SET_DELETED,
        ids
    }),
    setWaitingComments: (nodeId, documentId, is) => ({
        type: actionTypes.SET_WAIT_COMMENTS,
        nodeId,
        documentId,
        is
    }),
    setWaitingLikes: (nodeId, documentId, is) => ({
        type: actionTypes.SET_WAIT_LIKES,
        nodeId,
        documentId,
        is
    }),
    setDetailedPanelOpen: (detailedPanelOpen) => ({
        type: actionTypes.SET_DETAILED_PANEL_OPEN,
        detailedPanelOpen
    })
};
